import React, {createContext, useContext, useState, useEffect} from "react";
import {useTranslation} from "react-i18next";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({children}) => {
  const {i18n} = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || "en");

  useEffect(() => {
    setCurrentLanguage(i18n.language);

    // Add RTL support for Arabic
    const direction = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", i18n.language);
  }, [i18n.language]);

  const changeLanguage = language => {
    i18n.changeLanguage(language);
    setCurrentLanguage(language);

    // Update direction and language attributes
    const direction = language === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", language);
  };

  const value = {
    currentLanguage,
    changeLanguage,
    isRTL: currentLanguage === "ar"
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
